export default {
    // Mining effects
    miningDamage: {
        feature: 'mining',
        icon: 'mdi-bomb',
        value: 0.5,
    },
    currencyMiningScrapGain: {
        feature: 'mining',
        icon: 'mdi-dots-triangle',
        value: 0.65,
    },
    miningOreGain: {
        feature: 'mining',
        icon: 'mdi-chart-bubble',
        value: 0.2,
    },
    miningRareEarthGain: {
        feature: 'mining',
        icon: 'mdi-landslide',
        value: 0.2,
    },
    miningSmelteryTime: {
        feature: 'mining',
        unlock: 'miningSmeltery',
        icon: 'mdi-fire',
        minTier: 1,
        value: 0.35,
        scaling: 'divisive',
    },
    currencyMiningCrystalGreenGain: {
        feature: 'mining',
        type: 'prestige',
        icon: 'mdi-star-three-points',
        max: 3,
        minTier: 1,
        value: 0.1,
    },
    currencyMiningCrystalYellowGain: {
        feature: 'mining',
        unlock: 'miningGasSubfeature',
        type: 'prestige',
        icon: 'mdi-star-four-points',
        max: 3,
        minTier: 2,
        value: 0.1,
    },

    // Village effects
    queueSpeedVillageBuilding: {
        feature: 'village',
        icon: 'mdi-hammer',
        value: 0.4,
    },
    currencyVillageCoinGain: {
        feature: 'village',
        icon: 'mdi-circle-multiple',
        value: 0.5,
    },
    villageFoundationMaterialGain: {
        feature: 'village',
        icon: 'mdi-tree',
        value: 0.2,
    },
    villageIndustrialMaterialGain: {
        feature: 'village',
        unlock: 'villageBuildings2',
        icon: 'mdi-mirror',
        value: 0.2,
    },
    villageLuxuryMaterialGain: {
        feature: 'village',
        unlock: 'villageBuildings4',
        icon: 'mdi-diamond',
        minTier: 1,
        value: 0.2,
    },
    villageModernMaterialGain: {
        feature: 'village',
        unlock: 'villageBuildings7',
        icon: 'mdi-oil',
        minTier: 2,
        value: 0.2,
    },
    currencyVillageFaithGain: {
        feature: 'village',
        type: 'prestige',
        icon: 'mdi-hands-pray',
        max: 3,
        minTier: 1,
        value: 0.1,
    },
    currencyVillageSharesGain: {
        feature: 'village',
        unlock: 'villageCraftingSubfeature',
        type: 'prestige',
        icon: 'mdi-certificate',
        max: 3,
        minTier: 2,
        value: 0.1,
    },

    // Horde effects
    hordeAttack: {
        feature: 'horde',
        icon: 'mdi-sword',
        value: 0.35,
    },
    currencyHordeBoneGain: {
        feature: 'horde',
        icon: 'mdi-bone',
        value: 0.6,
    },
    currencyHordeCorruptedFleshGain: {
        feature: 'horde',
        unlock: 'hordeCorruptedFlesh',
        icon: 'mdi-food-steak',
        value: 0.15,
    },
    hordeEquipmentMasteryGain: {
        feature: 'horde',
        unlock: 'hordeEquipmentMastery',
        icon: 'mdi-seal',
        minTier: 1,
        value: 0.2,
    },
    hordeShardChance: {
        feature: 'horde',
        unlock: 'hordeBrickTower',
        icon: 'mdi-billiards-rack',
        minTier: 2,
        value: 0.15,
    },
    currencyHordeBloodGain: {
        feature: 'horde',
        unlock: 'hordeClassesSubfeature',
        icon: 'mdi-iv-bag',
        minTier: 3,
        value: 0.6,
    },
    currencyHordeSoulCorruptedGain: {
        feature: 'horde',
        type: 'prestige',
        icon: 'mdi-ghost',
        max: 3,
        minTier: 1,
        value: 0.1,
    },
    currencyHordeCourageGain: {
        feature: 'horde',
        unlock: 'hordeClassesSubfeature',
        type: 'prestige',
        icon: 'mdi-ghost',
        max: 3,
        minTier: 3,
        value: 0.1,
    },

    // Farm effects
    currencyFarmVegetableGain: {
        feature: 'farm',
        icon: 'mdi-carrot',
        value: 0.55,
    },
    currencyFarmBerryGain: {
        feature: 'farm',
        icon: 'mdi-fruit-grapes',
        value: 0.55,
    },
    currencyFarmGrainGain: {
        feature: 'farm',
        icon: 'mdi-barley',
        value: 0.55,
    },
    currencyFarmFlowerGain: {
        feature: 'farm',
        icon: 'mdi-flower',
        value: 0.55,
    },
    farmExperience: {
        feature: 'farm',
        unlock: 'farmCropExp',
        type: 'prestige',
        icon: 'mdi-star',
        max: 3,
        minTier: 1,
        value: 0.1,
    },

    // Gallery effects
    currencyGalleryBeautyGain: {
        feature: 'gallery',
        icon: 'mdi-image-filter-vintage',
        minTier: 1,
        value: 0.75,
    },
    galleryColorGain: {
        feature: 'gallery',
        icon: 'mdi-liquid-spot',
        minTier: 1,
        value: 0.1,
    },
    currencyGalleryConverterGain: {
        feature: 'gallery',
        unlock: 'galleryConversion',
        icon: 'mdi-recycle',
        minTier: 1,
        value: 0.5,
    },
    galleryShapeGain: {
        feature: 'gallery',
        unlock: 'galleryShape',
        icon: 'mdi-shape',
        minTier: 1,
        value: 0.65,
    },
    galleryCanvasSpeed: {
        feature: 'gallery',
        unlock: 'galleryCanvas',
        icon: 'mdi-package-variant',
        minTier: 2,
        value: 0.15,
    },
    currencyGalleryCashGain: {
        feature: 'gallery',
        type: 'prestige',
        icon: 'mdi-cash',
        max: 3,
        minTier: 1,
        value: 0.1,
    },
}
